(ns hypnos.backoffice.tile.anatomy
  "Anatomy tile."
  (:require [hypnos.backoffice.core.auth :as auth]
            [hypnos.backoffice.subs]
            [hypnos.backoffice.tile.field.anatomy-eye-glass-indentations :as anatomy-eye-glass-indentations]
            [hypnos.backoffice.tile.field.anatomy-facial-hair :as anatomy-facial-hair]
            [hypnos.backoffice.tile.field.anatomy-head :as anatomy-head]
            [hypnos.backoffice.tile.field.anatomy-iris :as anatomy-iris]
            [hypnos.backoffice.tile.field.anatomy-nose :as anatomy-nose]
            [hypnos.backoffice.tile.field.anatomy-pixels :as anatomy-pixels]
            [hypnos.graphql.mutations :as mutations]
            [hypnos.i18n :refer [tr]]
            [hypnos.translator.patient :as t-p]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Helpers

(defn- iris-actionable?
  "Is the consult actionable for IRIS (super) users?"
  [state]
  (let [patient        (:patient state)
        patient-image  (get-in patient [:patient/image :value])
        consult        (:patient/last-consult patient)
        consult-status (get-in consult [:consult/status :value])]
    (or (= :consult-state/in-progress consult-status)
        patient-image))
  #_(let [consult-status (:consult/status consult)
          patient        (:consult/patient consult)
          recomm-model   (:recommendation/model (first (:consult/recommendations consult)))]
      (or (= :consult-state/in-progress consult-status)
          (and (= :consult-state/pending consult-status)
               (:patient/image patient)
               (= :mask-size/fit-kit (:model/size recomm-model)))
          (and (= :consult-state/completed consult-status)
               (:patient/image patient)
               (= :mask-size/fit-kit (:model/size recomm-model))))))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Tile

(defn tile
  [state]
  (let [auth      (rf/subscribe [:backoffice/auth])
        patient   (rf/subscribe [:backoffice/patient])
        disabled? (not (iris-actionable? @state))]
    [:div.tile.is-ancestor
     [:div.tile.is-parent
      [:div.card.tile.is-child
       [:header.header.card-header
        [:p.card-header-title
         (tr :ui.label/anatomy)]
        (when (and (auth/authorized? @auth :make-recommendation)
                   (iris-actionable? @state))
          [:button.button.is-warning
           {:disabled (nil? (:patient/phone-number @patient))
            :on-click (fn [_]
                        (let [consult (:patient/last-consult @patient)]
                          (rf/dispatch [:amplify/mutation
                                        mutations/send-communication
                                        {:consult_id            (str (:consult/id consult))
                                         :communication_channel "sms"
                                         :communication_type    "portrait"}
                                        :backoffice/refresh-patient])))}
           [:span.icon [:i.mdi.mdi-message-bulleted.default]]
           [:span (tr :ui.label/new-portrait)]])
        (when (and (auth/authorized? @auth :make-recommendation)
                   (iris-actionable? @state))
          [:a.button.is-info
           {:href     "#"
            :disabled (or (nil? (get-in @state [:anatomy :anatomy/iris-diameter]))
                          (nil? (get-in @state [:anatomy :anatomy/head-height]))
                          (nil? (get-in @state [:anatomy :anatomy/head-width]))
                          (nil? (get-in @state [:anatomy :anatomy/nose-length]))
                          (nil? (get-in @state [:anatomy :anatomy/nose-width]))
                          (nil? (get-in @state [:anatomy :anatomy/nose-to-clef])))
            :on-click (fn [_]
                        ;; submit anatomy information
                        (swap! state assoc-in [:patient :patient/id :value] nil)
                        (rf/dispatch-sync [:amplify/mutation
                                           mutations/store-anatomy
                                           {:patient (t-p/patient->gql (dissoc @patient
                                                                               :patient/image
                                                                               :patient/mask
                                                                               :patient/selector
                                                                               :patient/selector-type
                                                                               :patient/anatomy
                                                                               :patient/last-consult
                                                                               :patient/recommendations
                                                                               :communication/_recipient))
                                            :anatomy (t-p/anatomy->gql (:anatomy @state))}
                                           :backoffice/set-patient
                                           :backoffice/set-error]))}
           [:span (tr :ui.label/submit)]])]
       [:div.card-content
        [:div.columns
         [:div.column
          (when (and (auth/authorized? @auth :make-recommendation)
                     (iris-actionable? @state))
            [:div
             [anatomy-pixels/iris-field state {:disabled disabled?}]
             [anatomy-pixels/head-field state {:disabled disabled?}]
             [anatomy-pixels/nose-field state {:disabled disabled?}]
             [anatomy-pixels/nare-clef-field state {:disabled disabled?}]
             [:hr]])
          [anatomy-iris/field state {:disabled true}]
          [anatomy-head/field state {:disabled true}]
          [anatomy-nose/nose-field state {:disabled true}]
          [anatomy-nose/nare-clef-field state {:disabled true}]
          [anatomy-facial-hair/field state {:disabled disabled?}]
          [anatomy-eye-glass-indentations/field state {:disabled disabled?}]]]]]]]))
